export default __webpack_public_path__ + "static/media/CustomerRealCase1-en-moblie.61fb6777.jpg";